// @ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { IconButton, ListItemSecondaryAction, Typography } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button/Button';
import { CreateSuperUserFormValidation } from './create-super-user-page';
import { EditSuperUserForm } from './edit-super-user-form';

function AddSuperUser({ client }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {!open && (
        <Button variant="outlined" color="primary" fullWidth onClick={handleClickOpen}>
          <AddIcon /> Add Super User
        </Button>
      )}

      {open && <CreateSuperUserFormValidation client={client} handleClose={handleClose} />}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  },
  heading: {
    margin: theme.spacing(2)
  },
  fab: {
    width: '100%'
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

function SuperUser({ client, user }) {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <List className={classes.root}>
        <ListItem>
          <ListItemAvatar>
            <Avatar alt={user.firstname} src="/static/images/avatar/1.jpg" />
          </ListItemAvatar>
          <ListItemText
            primary={`${user.firstname} ${user.lastname}`}
            secondary={null}
          ></ListItemText>

          <ListItemSecondaryAction>
            {!open && (
              <IconButton edge="end" aria-label="comments" onClick={handleClickOpen}>
                <EditIcon />
              </IconButton>
            )}
            {open && (
              <IconButton edge="end" aria-label="comments" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            )}
          </ListItemSecondaryAction>
        </ListItem>
      </List>

      {open && (
        <>
          <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
            <small>
              <b>Edit Super User</b>
            </small>
          </Typography>
        </>
      )}

      {open && <EditSuperUserForm client={client} handleClose={handleClose} />}
    </>
  );
}

export function SuperUserComponent({ client }) {
  const classes = useStyles();

  const users = client.users.filter((user) => user.permissions?.superuser === true);

  return (
    <div>
      <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
        <small>
          <b>Super user</b>
        </small>
      </Typography>

      {<AddSuperUser client={client} />}

      {users.map((user, index) => (
        <SuperUser key={index} client={client} user={user} />
      ))}
    </div>
  );
}
